<app-search-univ-result-base
  [searchResults]="searchResultsToDisplay"
  [isBtoC]="isBtoC"
  [selectedExamType]="selectedExamType"
  (goToPaperDetailClick)="goToPaperDetail($event)"
  (goToUnivDetailClick)="goToUnivDetail($event)"
></app-search-univ-result-base>
